// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__207GD","upload":"Small_upload__3qF8o","imageWrap":"Small_imageWrap__hY-us","removeBtn":"Small_removeBtn__Az0pr"};